import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import messages from './Partners.intl';

import styles from './Partners.module.scss';

import { Container } from 'common/components/Layout/Layout';

import PartnersStore from 'stores/Partners.store';
import Carousel from 'common/components/Carousel/Carousel';
import PartnerBox from './components/ParnterBox/PartnerBox';

@injectIntl
@observer
export default class Partners extends Component {
  componentDidMount() {
    PartnersStore.fetchPartners();
  }

  render() {
    const { partners } = PartnersStore;
    const carouselSettings = {
      className: styles.Carousel,
      slidesToShow: 4,
      autoplay: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 760,
          settings: {
            autoplay: false,
            arrows: true,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            autoplay: false,
            arrows: true,
            slidesToShow: 1
          }
        }
      ]
    };
    return (
      PartnersStore.isLoaded() && (
        <div className={styles.BackgroundContainer}>
          <Container>
            <div className={styles.Wrapper}>
              <h2 className={styles.HeaderTitle}>
                {this.props.intl.formatMessage(messages.heading)}
              </h2>
              <Carousel settings={carouselSettings}>
                {partners.map((partner, index) => (
                  <PartnerBox key={index} partner={partner} />
                ))}
              </Carousel>
            </div>
          </Container>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Partners/Partners.js